import { render, staticRenderFns } from "./PanelView.vue?vue&type=template&id=2b4edc0c"
import script from "./PanelView.vue?vue&type=script&lang=js"
export * from "./PanelView.vue?vue&type=script&lang=js"
import style0 from "./PanelView.vue?vue&type=style&index=0&id=2b4edc0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports